exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".top-bar{margin-top:-25px;height:95px;width:auto;position:relative;background-color:#ececec;margin-bottom:50px}.top-bar .content-wrapper{position:relative;margin-bottom:15px;right:0;padding-top:15px}.top-bar .content-wrapper:before{position:relative}.top-bar .content-wrapper:after{content:\"\";width:0;height:0;position:relative;display:block;margin-left:-25px;top:15px;border-left:25px solid transparent;border-right:25px solid transparent;border-top:25px solid #ececec}.top-bar .breadcrumbs{position:absolute;right:0;top:37px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75e6522e","scoped":false,"hasInlineConfig":true}!./src/components/top-bar/top-bar.css
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-75e6522e","scoped":false,"hasInlineConfig":true}!./src/components/top-bar/top-bar.css
// module chunks = index